export default {
  allMail: "/system/syncedEmail/allMail",
  threadIndex: "",
};
